import { map } from 'rxjs/operators';
// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
// Utils
import { formFlattenedObject, formFlattenedParamString } from 'NewAngular/utils/urls';
import { convertNestedStringToBoolean } from 'NewAngular/utils/state-utils';
// Constants
import { FUND_CHART_DATA_KEYS } from 'ChartApp/ts/features/fundamental-chart/constants';
import { PARTNER_OPTION_DEFAULT } from 'ChartApp/ts/features/charts-shared/constants';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class FundChartService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
        this.serializedKeys = [];
        this.serializedKeys = FUND_CHART_DATA_KEYS.concat(['redesign', 'chartCreator', 'sortColumn', 'sortDirection']);
    }
    chartHasNoData(chartData) {
        // chartHasNoData is true if the chart has undefined, null or empty data
        if (!chartData || !chartData.chart_data)
            return true;
        // Check each data series, chartHasNoData is false if any are non-empty
        for (let i = 0; i < chartData.chart_data.length; i += 1) {
            for (let j = 0; j < chartData.chart_data[i].length; j += 1) {
                if (chartData.chart_data[i][j].raw_data.length > 0) {
                    return false;
                }
            }
        }
        return true;
    }
    getFlattenedFormData(fundChartState) {
        const state = { ...fundChartState, redesign: true };
        return formFlattenedObject(state, this.serializedKeys);
    }
    getChartDataFromUrl(chartDataUrl, chartCreator = false) {
        return this.ajaxService.getDataObserveBody(chartDataUrl, { chartCreator }).pipe(map((response) => {
            convertNestedStringToBoolean(response.params);
            return response;
        }));
    }
    getChartDataFromState(fundChartState, chartCreator = false) {
        const chartDataBaseUrl = this.urlsService.CHARTS.FUND_CHART_DATA.json;
        return this.ajaxService
            .postFormEncodedDataObserveBody(chartDataBaseUrl, {
            ...fundChartState,
            chartCreator,
        })
            .pipe(map((response) => {
            convertNestedStringToBoolean(response.params);
            return response;
        }));
    }
    getChartCSVDataFromState(fundChartState) {
        const chartDataBaseUrl = this.urlsService.CHARTS.FUND_CHART_DATA.csv;
        const state = { ...fundChartState, redesign: true };
        const data = formFlattenedObject(state, this.serializedKeys);
        return this.ajaxService.postFormEncodedDataWithBlobObserveResponse(chartDataBaseUrl, data);
    }
    getChartDataUrl(fundChartState) {
        // If we do not have securities, correlations, or a security list,
        // we are not requesting data
        const chartUrlParams = this.getChartDataUrlQuery(fundChartState);
        const chartDataBaseUrl = this.urlsService.CHARTS.FUND_CHART_DATA_JSON;
        return `${this.urlsService.getUrl(chartDataBaseUrl)}?${chartUrlParams}`;
    }
    getChartDataUrlQuery(fundChartState) {
        // Add 'redesign' true for Node
        const state = { ...fundChartState, redesign: true };
        const serializedKeys = FUND_CHART_DATA_KEYS.concat([
            'redesign',
            'chartAnnotations',
            'axisExtremes',
            'sortColumn',
            'sortDirection',
        ]);
        return formFlattenedParamString(state, serializedKeys, true);
    }
    /* eslint-disable no-param-reassign */
    getChartEmbedUrl(fundChartState, embedType) {
        const nodeBaseUrl = `${process.env.NODE_BASE_URL}`;
        const urlExtension = this.urlsService.getUrl(this.urlsService.EMBEDS.FUND_CHART, { mode: embedType });
        let state = fundChartState;
        if (!fundChartState.partner) {
            state = { ...fundChartState, partner: PARTNER_OPTION_DEFAULT };
        }
        const queryParams = this.getChartDataUrlQuery(state);
        return `${nodeBaseUrl}${urlExtension}&${queryParams}`;
    }
    getChartShareUrl(baseShareUrl, fundChartState) {
        const data = this.getFlattenedFormData(fundChartState);
        return this.ajaxService.postFormEncodedDataObserveBody(baseShareUrl, data);
    }
    getChartSaveAsImageUrl(fundChartState) {
        const baseUrl = this.urlsService.EMBEDS.SAVE_AS_IMAGE_FUND_CHART;
        const state = { ...fundChartState, redesign: true };
        const serializedKeys = FUND_CHART_DATA_KEYS.concat([
            'redesign',
            'chartAnnotations',
            'axisExtremes',
            'sortColumn',
            'sortDirection',
        ]);
        const data = formFlattenedObject(state, serializedKeys);
        return this.ajaxService.postFormEncodedDataObserveResponse(baseUrl, data);
    }
    getChartDisclosure(fundChartState) {
        const url = this.urlsService.DISCLOSURES.FUND_CHART_DISCLOSURE;
        const data = this.getFlattenedFormData(fundChartState);
        return this.ajaxService.postFormEncodedDataWithTextObserveResponse(url, data);
    }
}
FundChartService.ɵfac = function FundChartService_Factory(t) { return new (t || FundChartService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
FundChartService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FundChartService, factory: FundChartService.ɵfac, providedIn: 'root' });
